import { classnames } from '@tailwindcss-classnames';

// bread crumbs
export const breadCrumbPageLabel = classnames(
  'text-nzxt-light-grey-800',
  'ml-1'
);

export const breadCrumbWrapper = classnames(
  'flex',
  'items-center',
  'justify-between'
);
export const breadCrumb = classnames(
  'text-sm',
  'text-nzxt-light-grey-600',
  'flex',
  'items-center',
  'font-semibold'
);
export const breadCrumbItem = classnames(
  'font-bold',
  'hover:underline',
  'mr-1'
);

// outerWrapper
export const outerWrapper = classnames(
  'bg-white',
  'opacity-100',
  'py-2',
  'lg:fixed',
  'border-b',
  'w-screen',
  'lg:z-20',
  'overflow-hidden'
);

export const innerWrapper = classnames(
  'bg-white',
  'w-full',
  'flex',
  'justify-between',
  'max-w-screen-2xl',
  'relative',
  'm-auto',
  'w-full',
  'md:py-2.5',
  'py-2',
  'overflow-hidden'
);

export const productName = classnames('font-semibold');

const activeAction = classnames('rotate-180');
export const chevron = (isActive: boolean): string =>
  classnames(
    'h-5',
    'w-5',
    {
      [activeAction]: isActive,
    },
    'stroke-current',
    'ml-1',
    'transition-transform',
    'duration-200',
    'transform',
    'group-nested-link-hover:text-nzxt-volt-400'
  );

export const linksWrapper = classnames('flex', 'items-center');

export const anchorLinks = classnames(
  'mx-auto',
  'capitalize',
  'py-2',
  'focus:outline-none'
);
export const extendedButtonStyles = classnames('mr-0', 'ml-4');

export const sectionDrowpdownButton = classnames(
  'inline-flex',
  'justify-center',
  'items-center',
  'w-full',
  'px-4',
  'md:px-10',
  'px-4',
  'py-1',
  'bg-white',
  'font-semibold',
  'text-nzxt-dark-grey-600',
  'h-10'
);

export const dropdownContainer = classnames(
  'origin-top-right',
  'absolute',
  'right-0',
  'mt-3',
  'w-56',
  'rounded-md',
  'overflow-hidden',
  'border-none',
  'shadow-lg',
  'bg-white',
  'min-w-full'
);

export const anchorLinkWrapperSmall = classnames(
  'origin-top-right',
  'absolute',
  '-right-40',
  'top-27',
  'overflow-hidden',
  'border-none',
  'shadow-lg',
  'bg-white',
  'ring-1',
  'ring-black',
  'ring-opacity-5',
  'min-w-full',
  'w-screen'
);
export const buttonWrapper = classnames('flex', 'flex-col', 'py-1');
export const button = classnames('mr-0', 'ml-4');
